import { Image, Text } from '@ui/atoms';
import FDCarousels from '@components/Products/FixedDeposits/Carousel/FDCarousels';
import { fdCarouselContent } from '@components/Products/FixedDeposits/utils/helper';
import texts from '@components/Products/FixedDeposits/en.json';
import Button from '@ui/atoms/design-system/Button';

const FixedDepositsCarousel = ({ fixedDepositBanks, handleOnClick }) => {
    return (
        <section className="relative w-full py-8 xl:pt-10 xl:pb-2 xl:px-4">
            <div className='relative z-50'><div className="flex flex-col gap-2 xl:gap-4">
                <Text
                    content={fdCarouselContent.title}
                    className="h4-semibold md:h3-semibold xl:h2-semibold text-center text-gray-500 px-4"
                    isInnerHtml
                    htmlTag="h2"
                />
                <Text
                    content={fdCarouselContent.description}
                    className="text-center text-gray-600 p4-regular xl:p2-regular px-4"
                    htmlTag="p"
                />
            </div>
            <FDCarousels fixedDepositBanks={fixedDepositBanks} />
            <div className="flex justify-center mt-8 xl:mt-6">
                <Button
                    onClick={handleOnClick}
                    buttonText={texts?.bookFdNow}
                    buttonSize="large"
                />
            </div>
            </div>
            <div
                style={{ pointerEvents: 'none' }}
                className={`absolute hidden xl:block left-0 bottom-0 z-0`}
            >
                <Image src={'/images/products/sdis-bg-left.svg'} />
            </div>
        </section>
    );
};

export default FixedDepositsCarousel;
